import React from 'react';

const EmailVisualizadoIcon = ({ color = '#233d4d', size = 30 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 22.308 16.5">
    <g id="Grupo_1615" data-name="Grupo 1615" transform="translate(-1088 -319)">
      <path
        id="Icon_material-email"
        data-name="Icon material-email"
        d="M20.1,6H4.9A1.885,1.885,0,0,0,3.01,7.875L3,19.125A1.893,1.893,0,0,0,4.9,21H20.1A1.893,1.893,0,0,0,22,19.125V7.875A1.893,1.893,0,0,0,20.1,6Zm0,3.75-7.6,4.688L4.9,9.75V7.875l7.6,4.688,7.6-4.687Z"
        transform="translate(1085 313)"
        fill={color}
      />
      <path
        id="Icon_awesome-eye"
        data-name="Icon awesome-eye"
        d="M12.673,8.427A7.1,7.1,0,0,0,6.375,4.5a7.1,7.1,0,0,0-6.3,3.927.716.716,0,0,0,0,.646A7.1,7.1,0,0,0,6.375,13a7.1,7.1,0,0,0,6.3-3.927A.716.716,0,0,0,12.673,8.427Zm-6.3,3.511A3.187,3.187,0,1,1,9.563,8.75,3.188,3.188,0,0,1,6.375,11.938Zm0-5.312a2.11,2.11,0,0,0-.56.084A1.059,1.059,0,0,1,4.334,8.19,2.12,2.12,0,1,0,6.375,6.625Z"
        transform="translate(1097.051 322)"
        fill="#fff"
        stroke={color}
        strokeWidth="1"
      />
    </g>
  </svg>
);

export default EmailVisualizadoIcon;
